import * as React from 'react';
import classNames from 'classnames';
import { Link, useNavigate } from 'react-router-dom';
import Image from '../Elements/Image';

export const Header = ({
  className,
  navPosition,
  hideNav,
  hideSignin,
  bottomOuterDivider,
  bottomDivider,
  ...props
}) => {

  const classes = classNames(
    'site-header',
    bottomOuterDivider && 'has-bottom-divider',
    className
  );

  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/');
  };

  return (
    <header
      {...props}
      className={classes}
    >
      <nav className='navbar navbar-expand-lg nav-highbar'>
        <div className='container-fluid'>
          <ul className='nav topbar'>
            <span className='navbar-text'>
              <i className="fa fa-phone phone-style" aria-hidden="true"></i>
            </span>
            <li className='nav-item'>
              <Link className='nav-link phone-number-style' to='tel:+1(303)914-3821'>(303) 914-3821</Link>
            </li>
            <li className='nav-item'>
              <div className='nav-link disabled seperator-style'>|</div>
            </li>
            <li className='nav-item'>
              <div className='nav-link disabled hours-style'>Mon - Fri, 8 AM to 5 PM (MST)</div>
            </li>
          </ul>
        </div>
      </nav>
      <nav className='navbar navbar-expand-lg nav-lowbar'>
        <div className='container-fluid'>
          <ul className='nav lowbar'>
            <div className="navbar-brand" to="#">
              <Image
              src={require('../../assets/images/logo.png')}
              alt="Open"
              width={142.142}
              height={43.9}
              style={{ cursor: 'pointer' }}
              onClick={goToHome} />
            </div>
          </ul>
        </div>
      </nav>
    </header>
  );
}